import { RoutePathParams } from "@faire/web-api/routePath";
import { useParams } from "react-router-dom";

export const usePathParams = <T extends keyof RoutePathParams>(_route: T) =>
  useParams<{ [K in keyof RoutePathParams[T]]: string }>();
